// extracted by mini-css-extract-plugin
export default {"attribution":"attribution--UX3e5","attr_number":"attr_number--UX3e5","ctaAttr":"ctaAttr--UX3e5","ctaAttr_number":"ctaAttr_number--UX3e5"};